import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { ConfirmationComponent } from '@bca-confirmation/confirmation/confirmation.component';
import { SharedModule } from '@bca-shared/shared.module';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  declarations: [ConfirmationComponent],
  imports: [CommonModule, SharedModule, TranslateModule.forChild()],
  exports: [ConfirmationComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class ConfirmationModule {}
